export default __webpack_public_path__ + "static/media/Ballroll_00312.914e3896.png";